import { CHANGE_EVENT, getFavourites } from '@theme/favourites-store';

// Keeps the header heart badge and its accessible label in sync with saved favourites.
class SFavouritesCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#render();
    document.addEventListener(CHANGE_EVENT, () => this.#render(), opts);
    window.addEventListener('storage', () => this.#render(), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #render() {
    const count = getFavourites().length;
    const badge = this.querySelector('[data-favourites-badge]');
    const button = this.querySelector('button');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    if (button && this.dataset.labelTemplate) {
      button.setAttribute('aria-label', this.dataset.labelTemplate.replace('__COUNT__', String(count)));
    }
  }
}

if (!customElements.get('s-favourites-count')) {
  customElements.define('s-favourites-count', SFavouritesCount);
}
